export const apiPathConstants = {
  routePlanning: "route-planning",
  settings: "settings",
  orders: "orders",
  providers: "providers",
  haulerEmployees: "haulerEmployees",
  routes: "routes",
  /* params */
  routeSummaryId: "routeSummaryId",
  orderId: "orderId",
  routeId: "routeId",
  userId: "userId",
}

export const apiConstants = {
  UPSERT_SETTINGS: `/${apiPathConstants.settings}/:${apiPathConstants.userId}`,
  GET_ORDER_LIST: `${apiPathConstants.orders}`,
  GET_ORDER_DETAIL_BY_ID: `/${apiPathConstants.orders}/:${apiPathConstants.orderId}`,
  GET_PROVIDER_LIST: `/${apiPathConstants.providers}`,
  GET_HAULER_EMP_LIST: `/${apiPathConstants.haulerEmployees}`,
  GET_ROUTE_SUMMARY: `/${apiPathConstants.routes}/:${apiPathConstants.routeSummaryId}`,

  CREATE_ROUTE: `/${apiPathConstants.routePlanning}`,
  GET_ROUTE_LIST: `/${apiPathConstants.routePlanning}`,
  UPDATE_ROUTE: `/${apiPathConstants.routePlanning}/:${apiPathConstants.routeId}`,
}
